import { useState, useEffect } from 'react';
import { Content, Title } from 'components';
import { Button, Descriptions, Empty, Table, Checkbox } from 'antd';
import {
  useProductOptionDispatch,
  useProductOptionState,
} from '../context/ProductOptionProvider';
import { stringToMoneyFormat } from 'utils';
import { OrderedListOutlined } from '@ant-design/icons';
import styles from '../styles';
import ProductOptionAppendModal from './ProductOptionAppendModal';

const ProductOptionInformation = ({ defaultData }) => {
  const [isOpenAppendOption, setIsOpenAppendOption] = useState(false);
  const [modifyOption, setModifyOption] = useState(null);
  const state = useProductOptionState();
  const dispatch = useProductOptionDispatch();

  const handleDeleteOption = (optionId) => {
    dispatch({ type: 'DELETE_OPTION', value: optionId });
  };

  const handleAddOption = () => {
    setIsOpenAppendOption(true);
  };

  const handleModifyOption = (optionId) => {
    const findModifyOption = state.options.find(
      (option) => option.option_id === optionId
    );

    if (findModifyOption) {
      setModifyOption(findModifyOption);
      setIsOpenAppendOption(true);
    }
  };

  const handleAppendOption = (optionData) => {
    dispatch({ type: 'ADD_OPTION', value: optionData });
    setIsOpenAppendOption(false);
  };

  const handleModifyConfirmOption = (optionData) => {
    dispatch({ type: 'CHANGE_OPTION', value: optionData });
    setModifyOption(null);
    setIsOpenAppendOption(false);
  };

  const handleCloseOptionAppendModal = () => {
    setIsOpenAppendOption(false);
    setModifyOption(null);
  };

  useEffect(() => {
    if (defaultData && defaultData.product_option && dispatch) {
      defaultData.product_option.forEach((item) => {
        const optionData = {
          ...item,
          option: item.option.map((detailOption) => ({
            option_name: detailOption.option_name,
            option_price: detailOption.option_price,
          })),
        };

        dispatch({ type: 'ADD_OPTION', value: optionData });
      });
    }
  }, [defaultData]);

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Title size={5} align="left" style={{ marginBottom: 10 }}>
          <OrderedListOutlined /> 옵션 정보
        </Title>
        <Button type={'primary'} onClick={handleAddOption}>
          옵션 추가
        </Button>
      </div>
      {/* <InputFormTable form={form} /> */}
      {state.options.length === 0 ? (
        <div
          style={{
            width: '100%',
            height: '250px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Empty />
        </div>
      ) : (
        state.options.map((item) => (
          <div key={item.option_id} style={{ marginBottom: '15px' }}>
            <Descriptions
              bordered
              size="middle"
              labelStyle={{
                width: '200px',
                backgroundColor: '#F4F4F5',
                color: 'black',
              }}
              extra={
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Button
                    type="primary"
                    onClick={() => handleModifyOption(item.option_id)}
                  >
                    수정
                  </Button>
                  <Button
                    danger
                    onClick={() => handleDeleteOption(item.option_id)}
                  >
                    삭제
                  </Button>
                </div>
              }
              items={[
                { key: '1', label: '옵션명', children: item.option_title },
                {
                  key: '2',
                  label: '필수 옵션 설정',
                  children:
                    item.type === 'REQUIRED' ? '필수 옵션' : '추가 옵션',
                },
                { key: '3', label: '옵션 타입', children: '선택 옵션' },
                {
                  key: '4',
                  label: '하위 옵션',
                  children: (
                    <Table
                      pagination={false}
                      dataSource={item.option}
                      columns={[
                        {
                          title: '옵션항목',
                          dataIndex: 'option_name',
                          render: (title) => <span>{title}</span>,
                        },
                        {
                          title: '옵션항목 금액',
                          dataIndex: 'option_price',
                          render: (price) => (
                            <span>{stringToMoneyFormat(price)}원</span>
                          ),
                        },
                        {
                          title: '기본값',
                          dataIndex: 'default',
                          render: (value) => (
                            <Checkbox checked={value} disabled />
                          ),
                        },
                      ]}
                    />
                  ),
                },
              ]}
            />
          </div>
        ))
      )}
      <ProductOptionAppendModal
        isOpen={isOpenAppendOption}
        initialData={modifyOption}
        onClose={() => handleCloseOptionAppendModal()}
        onSave={handleAppendOption}
        onModify={handleModifyConfirmOption}
      />
    </Content>
  );
};

export default ProductOptionInformation;
